import { Box, SxProps } from '@mui/material';
import React from 'react';
import { IGridSize, IGridCardProps } from './interfaces';
import { defaultGridSize } from './data';
import GridCardRow from './GridCardRow';
import GridCardAction from './GridCardAction';
import {Theme} from "@mui/system";

/**
 * Old Grid Card
 * @param data
 * @param listId
 * @param headData
 * @param actionItems
 * @param rowMessageComponent
 * @param gridSize
 * @param firstRowGridSize
 * @param cardStyles
 * @param rowStyles
 * @param labelStyles
 * @param valueStyles
 * @param elementStyleActive
 * @param elementStyles
 * @param menuOpenListener
 * @param menuCloseListener
 * @constructor
 * @deprecated
 */
const GridCard = ({
  data,
  listId,
  headData,
  actionItems,
  rowMessageComponent,
  gridSize,
  firstRowGridSize,
  cardStyles,
  rowStyles,
  labelStyles,
  valueStyles,
  elementStyleActive,
  elementStyles,
  menuOpenListener,
  menuCloseListener
}: IGridCardProps) => {

  const headMatrix = (Array.isArray(headData[0])) ? headData : [headData];

  const itemGridSize: IGridSize = {
    ...defaultGridSize,
    ...gridSize,
  };

  const rowZeroGridSize: IGridSize = {
    ...firstRowGridSize,
    ...itemGridSize,
  };

  const rowNonZeroStyles: SxProps<Theme> = {
    ...rowStyles,
    'margin-top': 0,
  };
  
  return (
    <Box sx={{
      boxShadow: '0px 0px 0px 1px #E0E0E0',
      p: 1.5,
      borderRadius: '0.4em',
      position: 'relative',
      background: '#f5f5f5',
      ...(cardStyles && cardStyles)
    }}
    >
      {
        headMatrix.map((headData, rowNumber) => (
          <GridCardRow
            key={rowNumber} // need to change this to a unique key
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            data={data} // @ts-expect-error
            headData={headData}
            gridSize={rowNumber ? gridSize : rowZeroGridSize}
            rowStyles={rowNumber ? rowNonZeroStyles : rowStyles}
            labelStyles={labelStyles}
            valueStyles={valueStyles}
            elementStyleActive={elementStyleActive}
            elementStyles={elementStyles}
          />
        ))
      }
      <GridCardAction
        key={listId}
        actionItems={actionItems}
        dataItem={data}
        menuOpenListener={menuOpenListener}
        menuCloseListener={menuCloseListener}
      />
      {rowMessageComponent && rowMessageComponent()}
    </Box>
  );
};

export default GridCard;
